// extracted by mini-css-extract-plugin
export var splash = "style-module--splash--P60oL";
export var closed = "style-module--closed--LLR-f";
export var content = "style-module--content--MxcwK";
export var logo = "style-module--logo--qh-OJ";
export var slogan = "style-module--slogan--KMzqn";